export const DEV = process.env.NODE_ENV === 'dev';
export const HOST = process.env.API_ENV === 'BOE' ? 'fictum-boei18n.byteintl.net' : 'fizzo.org';
export const BASE_URL = `https://${HOST}`;
